(function () {
  class FancyGroupRule extends SlotsEngine.instantiators.SymbolRule {
    constructor() {
      super();
    }

    initialise(json) {
      let groupings = {};
      for (let i = 0; i < json.rules.length; ++i) {
        groupings = Object.assign(groupings, json.rules[i]);
      }
      this._weightings = [490, 350, 80, 7, 25, 8, 4, 4, 2, 18, 9, 2, 1];
      this._totalWeightings = this._weightings.reduce(function (
        accumulator,
        currentValue
      ) {
        return accumulator + currentValue;
      });
      super.initialise(groupings);
    }

    isSymbolValid(symbolId, previousWindowSymbols, nextSymbol) {
      if (symbolId === previousWindowSymbols[previousWindowSymbols.length - 1])
        // cant continue the group from previous group
        return false;
      else if (symbolId === nextSymbol) return false;
      else if (!this.doesSymbolHaveRule(symbolId))
        // if there is no rule then it is fine
        return true;

      return true;
    }

    // used for unit tests, not used in client dev
    testReelBandPassesRule(reelBand) {
      for (let prop in this._rules) {
        if (this._rules.hasOwnProperty(prop)) {
          let symId = Number(prop);
          let count = this._rules[prop].count;
          for (let i = 0; i < reelBand.length; ++i) {
            if (reelBand[i] === symId) {
              let brokenRule = false;
              let matching = 1;
              for (let j = 1; j < count; ++j) {
                if (reelBand[(i + j) % reelBand.length] !== symId) {
                  brokenRule = true;
                  break;
                }
                ++matching;
              }
              if (reelBand[(i + count) % reelBand.length] === symId)
                brokenRule = true;

              if (brokenRule) {
                if (i === 0) {
                  // lets not stop just yet, it might wrap around completing the rule
                  let symbolsMissing = count - matching;
                  reelBand = reelBand
                    .slice(reelBand.length - symbolsMissing, reelBand.length)
                    .concat(reelBand);
                  reelBand.splice(
                    reelBand.length - symbolsMissing,
                    symbolsMissing
                  );
                  i = -1;
                } else {
                  return false;
                }
              } else {
                i += count - 1;
              }
            }
          }
        }
      }
      return true;
    }

    getNumSymbolsToReserve(symbolId) {
      if (!this.doesSymbolHaveRule(symbolId)) return 0;

      return this._rules["" + symbolId].count;
    }

    getReservedSymbols(symbol, num) {
      const validSymbols = this._rules["" + symbol].validSymbols;

      let symbols = [];
      for (let i = 0; i < num; ++i) {
        const weightValue = Math.floor(Math.random() * this._totalWeightings);
        let count = 0;
        for (
          let weightIndex = 0;
          weightIndex < this._weightings.length;
          ++weightIndex
        ) {
          count += this._weightings[weightIndex];
          if (weightValue < count) {
            const newSymbol =
              validSymbols[Math.floor(Math.random() * validSymbols.length)];
            symbols.push(newSymbol);
            break;
          }
        }
      }
      return symbols;
    }

    getAdditionalSymbolsNeededToSatisfyRule(symbolsInView) {
      let res = [];
      let lastSymbol = symbolsInView[symbolsInView.length - 1];

      let count = 0;
      for (let i = symbolsInView.length - 1; i >= 0; --i) {
        if (this.doesSymbolHaveRule(symbolsInView[i])) {
          ++count;
        } else {
          break;
        }
      }

      if (count > 0) {
        let numExtraNeeded = Math.max(
          this.getNumSymbolsNeeded(lastSymbol) - count,
          0
        );
        res = this.getReservedSymbols(lastSymbol, numExtraNeeded);
      }

      return res;
    }
  }
  resourceManager.registerController("SymbolRules_fancygroup", function () {
    return new FancyGroupRule();
  });
})();
